import { Notification } from './useNotifications.types';

import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';

export const useNotifications: BaseHookRequest<Notification[], null> = params => {
  const [{ getRequest }, state] = useApi<Notification[]>(params);
  const getNotifications: BaseRequest<null> = () => getRequest<null>('/manager/notification/all');

  return [getNotifications, state];
};
